import {
  FaBell,
  FaCheckCircle,
  FaEye,
  FaHome,
  FaSignOutAlt,
  FaThLarge,
  FaTimesCircle
} from "react-icons/fa";

import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "./css/AdminPayment.css";

function AdminPayment() {
  const navigate = useNavigate();
  const [notif, setNotif] = useState(true);
  const [data, setData] = useState([]);

  // 🔄 Ambil data dari MySQL via API Flask
  const fetchPayments = () => {
    fetch("http://localhost:5000/api/admin/payments")
      .then((res) => res.json())
      .then((resData) => {
        if (resData.status === "success") {
          setData(resData.data);
        }
      })
      .catch((err) => console.error("Gagal memuat data validasi pembayaran:", err));
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  // 🔔 NOTIF
  const handleBell = () => {
    setNotif(false);
    alert("Tidak ada notifikasi baru");
  };

  // 👁 LIHAT DETAIL
  const handleView = (item) => {
    alert(
      `Detail Transaksi:\n` +
      `-----------------------\n` +
      `ID Booking: ${item.id}\n` +
      `Nama Pelanggan: ${item.full_name}\n` +
      `Villa pilihan: ${item.villa_name}\n` +
      `Total Pembayaran: Rp ${Number(item.total_price).toLocaleString("id-ID")}\n` +
      `Status Validasi: ${item.status}`
    );
  };

  // ✅ SETUJUI PEMBAYARAN (Ubah ke 'Success')
  const handleApprove = (id) => {
    if (window.confirm("Setujui bukti pembayaran untuk booking ini?")) {
      fetch(`http://localhost:5000/api/admin/payments/${id}/status`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status: "Success" })
      })
        .then((res) => res.json())
        .then((resData) => {
          if (resData.status === "success") {
            alert("Pembayaran sukses dikonfirmasi!");
            fetchPayments(); // Reload data tabel & cards
          }
        })
        .catch((err) => console.error("Error saat approve:", err));
    }
  };

  // ❌ TOLAK PEMBAYARAN (Ubah ke 'Reject')
  const handleReject = (id) => {
    if (window.confirm("Tolak bukti pembayaran untuk booking ini?")) {
      fetch(`http://localhost:5000/api/admin/payments/${id}/status`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status: "Reject" })
      })
        .then((res) => res.json())
        .then((resData) => {
          if (resData.status === "success") {
            alert("Pembayaran telah ditolak.");
            fetchPayments(); // Reload data tabel & cards
          }
        })
        .catch((err) => console.error("Error saat reject:", err));
    }
  };

  // 🔥 LOGOUT
  const handleLogout = () => {
    localStorage.removeItem("adminLogin");
    navigate("/admin/login");
    window.location.reload();
  };

  return (
    <div className="admin-layout">

      {/* SIDEBAR */}
      <div className="sidebar">
        <div>
          <div className="sidebar-logo">
            <div className="logo-icon">🏨</div>
            <div>
              <h3>Permata Wisata</h3>
              <span>Portal Admin</span>
            </div>
          </div>

          <div className="menu">
            <Link to="/admin/dashboard" className="menu-item">
              <FaThLarge /> Dashboard
            </Link>
            <Link to="/admin/villas" className="menu-item">
              <FaHome /> Kelola Villa
            </Link>
            <Link to="/admin/transactions" className="menu-item">
              <FaThLarge /> Transaksi
            </Link>
            <Link to="/admin/payment" className="menu-item active">
              <FaCheckCircle /> Validasi Pembayaran
            </Link>
          </div>
        </div>

        <div className="logout" onClick={handleLogout} style={{ cursor: "pointer" }}>
          <FaSignOutAlt /> Keluar
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="main">

        {/* TOPBAR */}
        <div className="topbar">
          <div>
            <p className="welcome">Selamat datang kembali,</p>
            <h2>Admin</h2>
          </div>

          <div className="top-right">
            <div className="bell-wrapper">
              <FaBell className="bell" onClick={handleBell} />
              {notif && <span className="notif-dot"></span>}
            </div>

            <div className="admin-profile">
              <div className="avatar">A</div>
              <div className="admin-info">
                <span className="admin-name">Admin</span>
                <span className="admin-status">Aktif</span>
              </div>
            </div>
          </div>
        </div>

        {/* HEADER */}
        <div className="page-header">
          <h1>Validasi Pembayaran</h1>
          <p>Kelola dan verifikasi pembayaran pelanggan</p>
        </div>

        {/* CARDS COUNTER (Menghitung live sesuai status kapital database) */}
        <div className="stats-cards">
          <div className="card orange">
            <h3>Menunggu</h3>
            <h1>{data.filter(d => d.status === "Pending").length}</h1>
          </div>
          <div className="card green">
            <h3>Berhasil</h3>
            <h1>{data.filter(d => d.status === "Success").length}</h1>
          </div>
          <div className="card red">
            <h3>Ditolak</h3>
            <h1>{data.filter(d => d.status === "Reject").length}</h1>
          </div>
        </div>

        {/* TABLE */}
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>ID Booking</th>
                <th>Nama</th>
                <th>Villa</th>
                <th>Jumlah</th>
                <th>Status</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, i) => (
                  <tr key={item.id || i}>
                    <td>{item.id}</td>
                    <td>{item.full_name}</td>
                    <td>{item.villa_name}</td>
                    <td>
                      {item.total_price 
                        ? `Rp ${Number(item.total_price).toLocaleString("id-ID")}` 
                        : "Rp 0"}
                    </td>
                    <td>
                      {/* Kelas badge dipaksa lowercase (.toLowerCase()) agar CSS warna tetap berfungsi */}
                      <span className={`badge ${item.status ? item.status.toLowerCase() : 'pending'}`}>
                        {item.status === "Pending" && "Menunggu"}
                        {item.status === "Success" && "Berhasil"}
                        {item.status === "Reject" && "Ditolak"}
                      </span>
                    </td>
                    <td>
                      <button className="action-btn view" onClick={() => handleView(item)}>
                        <FaEye />
                      </button>
                      <button className="action-btn approve" onClick={() => handleApprove(item.id)}>
                        <FaCheckCircle />
                      </button>
                      <button className="action-btn reject" onClick={() => handleReject(item.id)}>
                        <FaTimesCircle />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center", padding: "20px", color: "#888" }}>
                    Tidak ada riwayat pembayaran di database.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}

export default AdminPayment;